
<template>
    <div>
        <div>
            <div class="col-lg-12" v-if="isLoadingBlade">
                <div class="d-flex justify-content-center">
                    <img :src="loadingBladeUrl" />
                </div>
            </div>

            <div class="container" v-if="! isLoadingBlade">
                <div class="row">
                    <div class="col-lg-2">
                        <base-input alternative="">
                            <select
                                class="form-control form-control-alternative"
                                v-model="page"
                                @change="getPageItems()"
                            >
                                <option
                                    v-for="(number, index) in visiblePages"
                                    :key="index"
                                    :value="number"
                                >
                                    {{ number }}
                                </option>
                            </select>
                        </base-input>
                    </div>
                    <div class="col-lg-10 text-right">
                        <div v-if="! hasExportPages">
                            <button
                                :class="'btn btn-lg btn-'+ (showFilters ? 'danger' : 'primary')"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                                @click="displayFilters()"
                            >
                                <i :class="'fa fa-'+(showFilters ? 'times' : 'sort')"></i>
                                {{ showFilters ? 'Remove Filters' : 'Filters Report'}}
                            </button>

                            <button
                                class="btn btn-lg btn-success"
                                @click="exportPaymentReport()"
                                v-if="records && records.length > 0"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                            >
                                <i class="fa fa-file-export"></i>
                                {{ isLoading ? 'Please Wait...' : 'Export Report'}}                            
                            </button>
                        </div>

                        <div v-if="hasExportPages">
                            <button
                                :class="'btn btn-lg btn-'+ (showFilters ? 'danger' : 'primary')"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                                @click="displayFilters()"
                            >
                                <i :class="'fa fa-'+(showFilters ? 'times' : 'sort')"></i>
                                {{ showFilters ? 'Remove Filters' : 'Filters Report'}}
                            </button>
                            <button
                                :class="'btn btn-lg btn-'+ (showExportPages ? 'danger' : 'success')"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                                @click="displayExportPages()"
                            >
                                <i :class="'fa fa-'+(showExportPages ? 'times' : 'sort')"></i>
                                {{ showExportPages ? 'Remove Export Pages' : 'Show Export Pages'}}
                            </button>
                        </div>
                    </div>

                    <div class="col-lg-12" v-if="hasExportPages && showExportPages">
                        <hr>
                        <form @submit.prevent="exportPaymentPagesReport">
                            <input
                                v-if="(item != 'limit')"
                                v-for="(value, item) in filters"
                                :key="item"
                                type="hidden"
                                :name="item"
                                :value="value"
                            />

                            <input
                                type="hidden"
                                name="limit"
                                :value="exportPerSheet"
                            />

                            <div class="col-lg-12 text-center">
                                <h3 class="text-danger">
                                    Note: Maximum of {{ exportPerSheet }} record(s) per export.
                                </h3>
                                <base-input label="Select Range of Records" required>
                                    <select
                                        class="form-control form-control-alternative"
                                        name="export_page"
                                        @change="enableExportPageButton()"
                                        required
                                    >
                                        <option  value="null" disabled selected>
                                            ---Select One---
                                        </option>
                                        <option
                                            v-for="page in exportPages"
                                            :key="page"
                                            :value="page"
                                        >
                                            Page {{ page }}
                                        </option>
                                    </select>
                                </base-input>
                            </div>

                            <button
                                class="btn btn-lg btn-success btn-block"
                                style="margin-top: 10px;"
                                nativeType="submit"
                                v-if="records && records.length > 0"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges || disableExportPageButton"
                            >
                                <i class="fa fa-file-export"></i>
                                {{ isLoading ? 'Please Wait...' : 'Export Page'}}
                            </button>
                        </form>
                        <hr>
                    </div>
                </div>
            </div>

            <div class="container" v-if="showFilters && ! isLoadingBlade">
                <hr>
                <h3 class="mb-0 text-uppercase text-center" v-html="filteredTitle"></h3>
                <hr v-if="! isFiltered">
                <div class="row" v-if="! isFiltered">
                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="Application Type"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="filters.application_type_id"
                                @change="getPaymentBreakdowns()"
                            >
                                <option value="null" selected disabled>--- Select One ---</option>
                                <option
                                    v-for="type in applicationTypes"
                                    :key="type.id"
                                    :value="type.id"
                                >
                                    {{ type.name }}
                                </option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4" v-if="subHeads && subHeads.length > 0">
                        <base-input alternative=""
                            label="Payment Sub Heads"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="selectedSubHead"
                            >
                                <option :value="null" disabled>--- Select One ---</option>
                                <option
                                    v-for="subHead in subHeads"
                                    :key="subHead.id"
                                    :value="subHead"
                                >
                                    {{ subHead.name }}
                                </option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4" v-if="showLicenseYear">
                        <base-input alternative=""
                            label="License Year"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="filters.license_year"
                            >
                                <option :value="null" selected disabled>--- Select One ---</option>
                                <option
                                    v-for="year in years"
                                    :value="year"
                                    :key="year"
                                >
                                    {{year}}
                                </option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="Gender"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="filters.gender"
                            >
                                <option :value="null" disabled>--- Select One ---</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="State of Practice"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="filters.state_practice"
                                @change="getStateLgas()"
                            >
                                <option :value="null" selected disabled>--- Select One ---</option>
                                <option
                                    v-for="state in locations.states"
                                    :value="state.id"
                                    :key="state.id"
                                >
                                    {{ state.name }}
                                </option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4" v-if="filters.state_practice && lgas && lgas.length > 0">
                        <base-input alternative=""
                            label="Lga of Practice"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="filters.lga_practice"
                            >
                                <option :value="null" selected disabled>--- Select One ---</option>
                                <option
                                    v-for="lga in lgas"
                                    :value="lga.id"
                                    :key="lga.id"
                                >
                                    {{ lga.name }}
                                </option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="Folio Number (In Full)"
                            input-classes="form-control-alternative text-capitalize"
                            placeholder="Enter Folio Number in full"
                            v-model="filters.folio"
                        />
                    </div>

                    <div class="col-lg-4" v-if="filters.application_type_id">
                        <base-input alternative=""
                            label="Surcharge (Penalty Fee Only)"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="filters.surcharge"
                            >
                                <option :value="null" disabled>--- Select One ---</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input
                            addon-left-icon="ni ni-calendar-grid-58"
                            label="Select Payment Date Range"
                        >
                            <flat-picker
                                slot-scope="{focus, blur}"
                                @on-open="focus"
                                @on-close="blur"
                                v-model="filters.date_range"
                                :config="{allowInput: true, mode: 'range'}"
                                class="form-control datepicker"
                            >
                            </flat-picker>
                        </base-input>
                    </div>

                    <div class="col-lg-12">
                        <button
                            class="btn btn-lg btn-info btn-block"
                            :disabled="(privileges && privileges.update == 'no') || ! privileges"
                            @click="applyFilters()"
                        >
                            <i class="fa fa-check"></i>
                            Apply Filters
                        </button>
                        <button
                            class="btn btn-lg btn-danger btn-block"
                            @click="displayFilters()"
                        >
                            <i class="fa fa-times"></i>
                            Remove Filters
                        </button>
                    </div>
                </div>
                <hr>
            </div>

            <!-- import Payment Report Data template here -->
            <PaymentReportData
                :records="records"
                :hasPagination="hasPagination"
                :pagination="pagination"
                :paginate="paginate"
                :privileges="privileges"
                :selectedSubHead="selectedSubHead"
                :totalAmount="totalAmount"
                :surcharge="filters.surcharge"
                v-if="! isLoadingBlade"
            />

        </div>

        <div
            class="col-sm-12 text-center"
            v-if="showErrorStatus"
        >
            <base-alert :type="errorType">
                <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                <span class="alert-inner--text">
                    {{errorMsg}}
                </span>
            </base-alert>
        </div>

    </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import moment from 'moment';
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import PaymentReportData from './PaymentReportData';
  import swal from 'sweetalert2';// import sweet alert

  export default {
    name: 'PaymentReport',
    props: ['privileges'],
    components: {
        PaymentReportData,
        flatPicker
    },
    data() {
      return {
        payment: [],
        showErrorStatus: false,
        errorType: null,
        errorMsg: null,
        isLoadingBlade: true,
        records: [],
        paginatedItems: [],
        pagination: {
            total: null,
            prev_page_url: null,
            next_page_url: null,
            current_page: null,
            last_page: null,
            number: 1,
            from: 0,
            to: null,
            // perPage: 2 // get per page count
            perPage: this.$store.state.url.perPage // get per page count
        },
        filters: {
            application_type_id: null,
            license_year: null,
            date_range: null,
            gender: null,
            state_practice: null,
            lga_practice: null,
            folio: null,
            surcharge: null,
            limit: this.$store.state.url.perPage // get per page count
        },
        totalAmount: null,
        selectedSubHead: null,
        page: 1,
        applicationTypes: [],
        subHeads: [],
        lgas: [],
        showFilters: false,
        isFiltered: false,
        showExportPages: false,
        disableExportPageButton: true,
        filteredTitle: 'Filtered Payment Report',
        isLoading: false
      }
    },
    filters: {
        formatDate(value) {
            return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
        },
    },
    computed: {
        ...mapGetters(['loadingBladeUrl', 'getRootUrl', 'user', 'exportPerSheet', 'locations', 'visiblePages',
            'getExportPaymentReportUrl']),
        hasPagination() {
            return this.pagination.next_page_url || this.pagination.prev_page_url;
        },
        years() {
            let startYear = moment().format('YYYY') - 119;// start from 1900
            let currentYear = (parseInt(moment().format('YYYY')) + 1);
            let years = [];
            for (let i = currentYear; i > startYear; i-- ) {
                years.push(i);
            }
            return years;
        },
        showLicenseYear() {
            return (this.filters.application_type_id == 7) || (this.filters.application_type_id == 15);
        },
        hasExportPages() {
            let divider = this.$store.state.url.exportPerSheet;
            return this.pagination.total > divider;
        },
        exportPages() {
            let divider = this.$store.state.url.exportPerSheet;
            let pages = Math.ceil(this.pagination.total / divider);
            return pages;
        }
    },
    methods: {
        ...mapActions(['getPayments', 'getPaginatedPaymentItems', 'getFilteredPayments', 'getExportPayments', 'getLocations', 'fetchNewPageData', 
            'downloadAssessmentFiles']),
        applyFilters() {// apply filters function
            let status = this.validFilterInputs();
            this.showErrorStatus = false;
            if(status) {
                this.preloader();// show loading
                if(this.selectedSubHead) {// add selected payment head
                    this.filters.breakdown_id = this.selectedSubHead.id;
                }
                this.getFilteredPayments(this.filters).then((res) => {// get users
                    this.isLoadingBlade = false;
                    this.setPages(res);//set data
                    this.isFiltered = true;
                    this.getFilteredTitle();// set filtered title
                    swal.close();
                }).
                catch(() => {
                    this.records = [];
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Server Failure!, Kindly reload the page...";
                    this.errorType = 'danger';
                });
            } else {
                let msg = 'Kindly select one of the filter actions, and try again';
                swal.fire('Invalid Selection', msg, 'warning');
            }
        },
        getFilteredTitle() {// set filtered payment title
            let data = this.filters;
            if(data.application_type_id) {
                this.filteredTitle = 'Payments for ';
                for(let type of this.applicationTypes) {
                    if(type.id == data.application_type_id) {
                        this.filteredTitle += type.name;
                        this.filteredTitle += (data.license_year ? ' ('+data.license_year+')' : '');
                    }
                }
            }
            this.filteredTitle += this.selectedSubHead ?  `, Payment Sub Head -> <em class="text-danger">${this.selectedSubHead.name}</em>` : '';
            this.filteredTitle += data.gender ?  `, Gender -> <em class="text-danger">${data.gender}</em>` : '';
            if(data.state_practice) {// add state of practice
                let state = this.locations.states.filter(item => item.id == data.state_practice);
                this.filteredTitle += `, State of Practice -> <em class="text-danger">${state[0].name}</em>`;
            }
            if(data.lga_practice) {// add lga of practice
                let lga = this.locations.lgas.filter(item => item.id == data.lga_practice);
                this.filteredTitle += `, LGA of Practice -> <em class="text-danger">${lga[0].name}</em>`;
            }
            this.filteredTitle += data.folio ?  `, Folio Number -> <em class="text-danger">${data.folio}</em>` : '';
            this.filteredTitle += data.surcharge ?  `, Surcharge -> <em class="text-danger">${data.surcharge}</em>` : '';
            if(data.date_range) {// Add date range to title
                let date = data.date_range.split('to');
                let from = this.formatRangeDate(date[0]);
                let to = this.formatRangeDate(date[1]);// eslint-disable-next-line
                this.filteredTitle += '<br><em><small>('+from+' to '+to+')<\small><\em>';
            }
            this.filteredTitle += ' Only';
        },
        formatRangeDate(value) {// format range date
            return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
        },
        validFilterInputs() {
            let data = this.filters;
            return data.application_type_id || data.date_range || data.gender || data.state_practice || data.folio;
        },
        displayFilters() {// diplay filters template
            this.emptyFilters();// empty filters
            // this.loadPayments();// reload payments
            this.showExportPages = false;
            return this.showFilters = ! this.showFilters;
        },
        emptyFilters() {// empty filters
            this.filters = {
                application_type_id: null,
                license_year: null,
                date_range: null,
                gender: null,
                state_practice: null,
                lga_practice: null,
                folio: null,
                surcharge: null,
                limit: this.$store.state.url.perPage // get per page count
            };
            this.isFiltered = false;
            this.filteredTitle = 'Filtered Payment Report';
            this.selectedSubHead = null;
            this.totalAmount = null;
        },
        loadPayments() {// load details
            let data = { limit : this.pagination.perPage };
            this.isLoadingBlade = true;
            this.showErrorStatus = false;
            this.getPayments(data).then((res) => {// get users
                this.isLoadingBlade = false;
                this.applicationTypes = this.modifyApplicationTypes(res.application_types);// modify app types
                this.setPages(res);//set data
                this.getLocations();
            }).
            catch(() => {
                this.records = [];
                this.showErrorStatus = true;
                this.isLoadingBlade = false;
                this.errorMsg = "Server Failure!, Kindly reload the page...";
                this.errorType = 'danger';
            });
        },
        setPages(data) {// set paginated function
            this.totalAmount = data.total_amount;// get total amount
            let res = data.payments;
            this.records = [];
            this.paginatedItems = res.data;
            this.records = this.paginatedItems;
            this.pagination.from = res.from;
            this.pagination.to = res.to;
            this.pagination.total = res.total;
            this.pagination.current_page = res.current_page;
            this.pagination.last_page = res.last_page;
            this.pagination.prev_page_url = res.prev_page_url;
            this.pagination.next_page_url = res.next_page_url;            
            this.fetchNewPageData({// handle pagination numbers
                current_page : res.current_page,
                last_page : res.last_page
            });
            this.isLoadingBlade = false;
            this.emptyRecordsMsg();//show empty msg
        },
        modifyApplicationTypes(types) {// remove medical education application types
            let medicalTypes = ["assessment-exam", "assessment-exam-resit", "hospital-medical-verify", 
                "hospital-dental-verify", "medical-school-accreditation", "medical-school-advisory", 
                "dental-school-accreditation", "dental-school-advisory", "cpd-application-fee", 
                "cpd-association-visitation-fee", "cpd-independent-visitation-fee", "cpd-independent-renewal-fee",
                "cpd-association-renewal-fee", "cpd-prov-reg"];
            return types.filter(item => ! medicalTypes.includes(item.code));
        },
        paginate() {// paginate function
            this.showErrorStatus = false;
            let url = (this.pagination.number > this.pagination.current_page) ?
                this.pagination.next_page_url : this.pagination.prev_page_url;
            if(url) {// make api call
                this.isLoadingBlade = true
                this.getPaginatedPaymentItems(url).then((res) => {// get users
                    this.pagination.number = res.payments.current_page;
                    this.setPages(res);
                }).
                catch(() => {
                    this.users = [];
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Server Failure!, Kindly reload the page...";
                    this.errorType = 'danger';
                });
            } else {
                this.records = this.paginatedItems;
            }
        },
        emptyRecordsMsg() {
            return this.records && this.records.length == 0 ? this.showEmptyMsg() : false;
        },
        showEmptyMsg() {// show empty msg
            this.showErrorStatus = true;
            this.errorType = 'warning';
            this.errorMsg = 'No Payments recorded yet!!!';
        },
        displayExportPages() {
            this.showFilters = false;
            return this.showExportPages = ! this.showExportPages;
        },
        getPageItems() {
            let url = this.pagination.next_page_url ?
                        this.pagination.next_page_url : this.pagination.prev_page_url;
            let exploded = url.split('&');
            let newUrl = exploded[0]+'&'+exploded[1]+'&'+exploded[2]+'&'+exploded[3]+'&page='+this.page;
            this.isLoadingBlade = true
            this.getPaginatedPaymentItems(newUrl).then((res) => {// get records
                this.pagination.number = res.payments.current_page;
                this.setPages(res);
            }).
            catch(() => {
                this.records = [];
                this.showErrorStatus = true;
                this.isLoadingBlade = false;
                this.errorMsg = "Server Failure!, Kindly reload the page...";
                this.errorType = 'danger';
            });
        },
        enableExportPageButton() {
            return this.disableExportPageButton = false;
        },
        getPaymentBreakdowns() {// get breakdowns
            let id = this.filters.application_type_id;
            let filtered = this.applicationTypes.filter(item => item.id == id);
            let type = filtered && filtered.length > 0 ? filtered[0] : false;
            return this.subHeads = type && type.has_payment ? type.has_payment.has_breakdowns : [];
        },
        getStateLgas() {
            let id = this.filters.state_practice;
            this.lgas = [];
            if(id) {
                for(let lga of this.locations.lgas) {
                    if(lga.state_id == id) {
                        this.lgas.push(lga);
                    }
                }
            }
        },
        preloader() {
            return  swal.fire({
                title: 'Please Wait...',
                html: 'Trying to fetch data from <b>server</b>',
                // timer: 2000,
                timerProgressBar: true,
                onBeforeOpen: () => {
                    swal.showLoading()
                },
            });
        },
        exportPaymentReport() {
            this.isLoading = true;
            const data = { 
                ...this.filters, 
                url : this.getExportPaymentReportUrl,
                contentType : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                fileName :  'payment-export.xlsx',
                msg : 'Failed to export Payment report sheet:'
            };
            return this.downloadAssessmentFiles(data).then((res) => {// download file
                this.isLoading = res; // stop loading
            });
        },
        exportPaymentPagesReport(event) {
            this.isLoading = true;
            const formData = new FormData(event.target);
            const payload = Object.fromEntries(formData.entries());// get entries

            const data = { 
                ...payload, 
                admin_id: this.user.id,
                url : this.getExportPaymentReportUrl,
                contentType : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                fileName :  'payment-export.xlsx',
                msg : 'Failed to export Payment report sheet:'
            };
            return this.downloadAssessmentFiles(data).then((res) => {// download file
                this.isLoading = res; // stop loading
            });
        }
    },
    mounted() {
        this.loadPayments();
    }
  };
</script>
<style>
    .table td {
        font-size: 15px;
    }
</style>
